import { render, staticRenderFns } from "./OverviewCategory.vue?vue&type=template&id=f62ef420"
import script from "./OverviewCategory.vue?vue&type=script&lang=ts"
export * from "./OverviewCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports